import React, { useEffect, } from 'react';
import styled from '@emotion/styled';
import { colors, typography, } from '@argo/principles';
import { Rating, } from '@argo/ui-elements';
import { Expander, } from '@argo/base-patterns';

export const ConsumerReviewsTitle = styled.div<any>`
  ${typography.types.bodyXL}
  padding-bottom: 16px;
`;

export const ConsumerReviewsNickName = styled.div<any>`
  ${typography.types.body}
  font-weight: ${typography.weight.bold};
  padding-bottom: 4px;
`;

export const ConsumerReviewsSubmissionDate = styled.div<any>`
  ${typography.types.bodySmall}
  padding-bottom: 8px;
`;

export const RatingContainer = styled.div<any>`
  font-size: 18px;
  line-height: 24px;
  display: inline-flex;
  font-family: ${typography.family.montserrat};
  color: ${colors.primary.black};
  font-weight: ${typography.weight.semiBold};
`;

type Props = {
  index: number;
  overallRating: string;
  title: string;
  nickName: string;
  submissionDate: string;
  text: string;
  onConsumerReviewsReadMoreClick: () => void;
}

const ConsumerReview = ({ index, overallRating, title, nickName, submissionDate, text, onConsumerReviewsReadMoreClick, }: Props): JSX.Element => {
  const expanderId = `consumer-reviews-expander-${index}`;

  const assignClickEventHandler = () => {
    let expanderText = document.querySelector(`#${expanderId}`)?.querySelector('button',)?.innerText;
    expanderText = expanderText?.toLowerCase();
    if (expanderText === 'read more') {
      onConsumerReviewsReadMoreClick();
    }
  };

  useEffect(() => {
    const expander = document.querySelector(`#${expanderId}`)?.querySelector('button',);

    if (expander) { // conditionally add click event listener on first render
      expander.addEventListener('click', () => {
        assignClickEventHandler();
      });
    }
    return () => { // remove event listener on clean up
      if (expander) {
        expander.removeEventListener('click', () => { assignClickEventHandler(); });
      }
    };
  });

  const overallRatingFixed = parseFloat(overallRating).toFixed(1);
  return (
    <div
      data-testid={`consumer-reviews-heading-${index}`}
      id={`consumer-reviews-heading-${index}`}
      style={{ paddingTop: '38px', }}
    >
      <div style={{ paddingBottom: '4px', }}>
        <RatingContainer>
          {overallRatingFixed}
          {' '}
        &nbsp;
          <Rating rating={Number(overallRatingFixed)} size="Small" />
        </RatingContainer>
      </div>
      <ConsumerReviewsTitle>{title}</ConsumerReviewsTitle>
      <ConsumerReviewsNickName>{nickName}</ConsumerReviewsNickName>
      <ConsumerReviewsSubmissionDate>{submissionDate}</ConsumerReviewsSubmissionDate>
      <div id={expanderId}>
        <Expander maxLines={4}>{text}</Expander>
      </div>
    </div>
  );
};
export default ConsumerReview;
